import { Plugin, ButtonView } from 'ckeditor5'
import BlockOptionsModal from './block-options-modal'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import {
  messageBoxHideAction,
  messageBoxShowAction,
} from 'src/reducers/message-box/action'

const findSimpleBoxWrapper = position => {
  let parent = position.parent

  while (parent) {
    if (parent.name === 'simpleBoxWrapper') {
      return parent
    }
    parent = parent.parent
  }

  return null
}
const handleAddNumberedCard = editor => {
  const selection = editor.model.document.selection
  const selectedElement = selection.getSelectedElement()

  const typeNumberedCard = selectedElement._children._nodes.filter(item => {
    return item._attrs && item._attrs.get('type') === 'numberedCard'
  })

  const typeHighlightCard = selectedElement._children._nodes.filter(item => {
    return item._attrs && item._attrs.get('type') === 'highlightCard'
  })

  const typeFlipCard = selectedElement._children._nodes.filter(item => {
    return item._attrs && item._attrs.get('type') === 'flipCard'
  })

  if (typeNumberedCard.length > 0) {
    editor.model.change(writer => {
      // Create the main card element
      const cardBox = writer.createElement('cardBox', {
        type: 'numberedCard',
      })

      // Create number container
      const cardHeader = writer.createElement('cardHeader')
      const pNumber = writer.createElement('paragraph')
      const number = '0' + (selectedElement?._children?._nodes?.length + 1)
      const textNumber = writer.createText(number.toString())

      // Create content container
      const cardContent = writer.createElement('cardContent')
      const pContent = writer.createElement('paragraph')
      const textContent = `I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!`
      // Build the structure safely
      writer.append(cardHeader, cardBox)
      writer.append(pNumber, cardHeader)
      writer.append(textNumber, pNumber)

      writer.append(cardContent, cardBox)
      writer.append(pContent, cardContent)
      writer.append(textContent, pContent)

      // Insert at the correct position
      if (selectedElement) {
        const position = writer.createPositionAt(selectedElement, 'end')
        writer.insert(cardBox, position)
        editor.editing.reconvertItem(selectedElement)
        editor.editing.view.forceRender()
      } else {
        const position = selection.getFirstPosition()
        writer.insert(cardBox, position)
        editor.editing.reconvertItem(selectedElement)
        editor.editing.view.forceRender()
      }
    })
  }
  if (typeHighlightCard.length > 0) {
    editor.model.change(writer => {
      // Create the main card element
      const cardBox = writer.createElement('cardBox', {
        type: 'highlightCard',
      })

      // Create number container
      const cardHeader = writer.createElement('cardHeader')
      const cardIconButton = writer.createElement('cardIconButton')
      const simpleIcon = writer.createElement('simpleIcon', {
        icon: 'lets-icons:add-round',
        iconname: 'lets-icons:add-round',
      })

      // Create content container
      const cardContent = writer.createElement('cardContent')
      const pContent = writer.createElement('paragraph')
      const textContent = `Normal text`
      // Build the structure safely
      writer.append(cardHeader, cardBox)
      writer.append(cardIconButton, cardHeader)
      writer.append(simpleIcon, cardIconButton)

      writer.append(cardContent, cardBox)
      writer.append(pContent, cardContent)
      writer.append(textContent, pContent)

      // Insert at the correct position
      if (selectedElement) {
        const position = writer.createPositionAt(selectedElement, 'end')
        writer.insert(cardBox, position)
        editor.editing.reconvertItem(selectedElement)
        editor.editing.view.forceRender()
      } else {
        const position = selection.getFirstPosition()
        writer.insert(cardBox, position)
        editor.editing.reconvertItem(selectedElement)
        editor.editing.view.forceRender()
      }
    })
  }
  if (typeFlipCard.length > 0) {
    editor.model.change(writer => {
      // Create the main card element
      const cardBox = writer.createElement('cardBox', {
        type: 'flipCard',
      })

      // Create number container
      const flipCardFront = writer.createElement('flipCardFront')
      const flipCardBack = writer.createElement('flipCardBack')
      const number = '0' + (selectedElement?._children?._nodes?.length + 1)
      const textNumber = writer.createText(number.toString())
      const pContentFront = writer.createElement('paragraph')
      const pContentBack = writer.createElement('paragraph')
      const flipCardFrontText =
        `Front of Card ` + (selectedElement?._children?._nodes?.length + 1)
      const flipCardBackText =
        `Back of Card ` + (selectedElement?._children?._nodes?.length + 1)
      // Build the structure safely
      writer.append(flipCardFront, cardBox)
      writer.append(flipCardBack, cardBox)
      writer.append(pContentFront, flipCardFront)
      writer.append(pContentBack, flipCardBack)

      writer.append(flipCardFrontText, pContentFront)
      writer.append(flipCardBackText, pContentBack)

      // Insert at the correct position
      if (selectedElement) {
        const position = writer.createPositionAt(selectedElement, 'end')
        writer.insert(cardBox, position)
        editor.editing.reconvertItem(selectedElement)
        editor.editing.view.forceRender()
      } else {
        const position = selection.getFirstPosition()
        writer.insert(cardBox, position)
        editor.editing.reconvertItem(selectedElement)
        editor.editing.view.forceRender()
      }
    })
  }
}

const handleAddButton = editor => {
  const selection = editor.model.document.selection
  editor.model.change(writer => {
    const simpleButton = writer.createElement('simpleButton', {
      href: '',
      textcolor: '#002E47',
      text: 'Button',
      type: 'link',
      pdfname: '',
    })

    const text = writer.createText('Button')

    const simpleIcon = writer.createElement('simpleIcon', {
      icon: '',
      iconname: 'lets-icons:add-round',
    })
    writer.append(simpleIcon, simpleButton)
    writer.append(text, simpleButton)

    const simpleBoxWrapper = findSimpleBoxWrapper(selection.getFirstPosition())
    if (simpleBoxWrapper) {
      const buttonWrapper = simpleBoxWrapper.getChild(0).getChild(0).getChild(0)
      const flexSize = simpleBoxWrapper
        .getChild(0)
        .getChild(0)
        .getAttribute('flex-size')

      if (flexSize === '3/1') {
        writer.append(
          simpleButton,
          editor.model.document.selection.getSelectedElement(),
        )
      } else {
        writer.append(simpleButton, buttonWrapper)
      }
    }
  })
}
const hideAllMessageBoxes = dispatch => {
  dispatch(messageBoxHideAction())
}
const handleAddModal = (dispatch, editor) => {
  // First, hide all existing message boxes

  // Call hideAllMessageBoxes before showing the new message box
  hideAllMessageBoxes(dispatch)

  // Then show the new message box
  dispatch(
    messageBoxShowAction(
      MessageBoxContent({
        type: MessageBoxType.WARNING,
        title: `<div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
          >
            <Typography>Block Options</Typography>
          </div>`,
        buttons: [],
        component: <BlockOptionsModal editor={editor} />,
        draggable: true,
        callback: () => {},
      }),
    ),
  )
}

class ButtonOptionsPlugin extends Plugin {
  constructor(editor) {
    super(editor)
    this.dispatch = editor.config.get('videoGalleryPlugin.dispatch')
    this.modalContainer = null
  }

  init() {
    const editor = this.editor

    // Initialize the modal container
    this.modalContainer = document.createElement('div')
    this.modalContainer.id = 'block-options-modal-container'
    document.body.appendChild(this.modalContainer)

    editor.ui.componentFactory.add('blockOptions', locale => {
      const view = new ButtonView(locale)
      view.set({
        label: 'Block Options',
        withText: true,
        tooltip: true,
        class: 'block-options',
      })

      view.on('execute', () => {
        handleAddModal(this.dispatch, editor)
      })
      return view
    })

    const buttonSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M6.99935 1.16699V12.8337M12.8327 7.00033H1.16602" stroke="#002E47" stroke-width="1.5" stroke-linecap="round"/>
                       </svg>`

    editor.ui.componentFactory.add('addButton', locale => {
      const view = new ButtonView(locale)
      view.set({
        label: 'Add Button',
        withText: true,
        icon: buttonSvg,
        tooltip: true,
        class: 'add-button',
      })

      view.on('execute', () => {
        handleAddButton(editor)
      })

      return view
    })

    editor.ui.componentFactory.add('addNumberedCard', locale => {
      const view = new ButtonView(locale)
      view.set({
        label: 'Add Card',
        withText: true,
        icon: buttonSvg,
        tooltip: true,
        class: 'add-numbered-card',
      })

      view.on('execute', () => {
        handleAddNumberedCard(editor)
      })

      return view
    })
  }
}

export default ButtonOptionsPlugin
